var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"my-swiper",attrs:{"autoplay":3000,"indicator-color":"#00C4C9"}},[_c('van-swipe-item',[_vm._v("1")]),_c('van-swipe-item',[_vm._v("2")]),_c('van-swipe-item',[_vm._v("3")]),_c('van-swipe-item',[_vm._v("4")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }